// UTM Parameter Capture and Storage
// Captures marketing source data for conversion tracking

export const captureUTMParameters = () => {
  const params = new URLSearchParams(window.location.search);
  
  const utmData = {
    utm_source: params.get('utm_source') || null,
    utm_medium: params.get('utm_medium') || null,
    utm_campaign: params.get('utm_campaign') || null,
    utm_term: params.get('utm_term') || null,
    utm_content: params.get('utm_content') || null,
    referrer: document.referrer || null,
    landing_page: window.location.pathname,
    captured_at: new Date().toISOString()
  };

  // Only store if we have at least one UTM parameter
  if (utmData.utm_source || utmData.utm_medium || utmData.utm_campaign) {
    localStorage.setItem('utmParameters', JSON.stringify(utmData));
    console.log('[UTM] Captured:', utmData);
  }

  return utmData;
};

export const getStoredUTMParameters = () => {
  const stored = localStorage.getItem('utmParameters');
  return stored ? JSON.parse(stored) : null;
};

export const clearUTMParameters = () => {
  localStorage.removeItem('utmParameters');
};

// Call this on app initialization
export const initializeUTMTracking = () => {
  // Only capture on first page load, not on every route change
  if (!sessionStorage.getItem('utm_captured')) {
    captureUTMParameters();
    sessionStorage.setItem('utm_captured', 'true');
  }
};